import React, { useEffect, useState } from "react";
import Create from "./Create";
import Edit from "./Edit";
import api from "../../api/api";
import Alerts from "../Alerts";
import { Button, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";

const View = () => {
  const [cards, setCards] = useState("");
  const [banners, setbanners] = useState([]);
  const [item, setItem] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // A função só será executada quando `cards` for uma string vazia.
    if (cards !== "") return;
    const fetchFeaturedProducts = async () => {
      setIsLoading(true);
      try {
        const response = await api.get("/mosaics");
        setbanners(response.data.mosaics);
      } catch (error) {
        console.error("Erro ao buscar mosaicos:", error);
        setWarning({
          type: "error",
          message: "Falha ao carregar os mosaicos do servidor!",
        });
        handleOpenSnackbar();
      } finally {
        setIsLoading(false);
      }
    };

    fetchFeaturedProducts();
  }, [cards]);

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleposition = (position) => {
    switch (position) {
      case "LEFT":
        return 1;
      case "RIGHT":
        return 2;
      case "BOTTOM_LEFT":
        return 3;
      case "BOTTOM_RIGHT":
        return 4;
      default:
        return 0;
    }
  };

  const getPositionColor = (position) => {
    switch (position) {
      case "LEFT":
        return "bg-blue-100 text-blue-800";
      case "RIGHT":
        return "bg-green-100 text-green-800";
      case "BOTTOM_LEFT":
        return "bg-purple-100 text-purple-800";
      case "BOTTOM_RIGHT":
        return "bg-orange-100 text-orange-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="max-w-7xl mx-auto p-2">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Gerenciar Mosaicos
        </h1>
        <p className="text-gray-600">
          Configure os mosaicos para exibição no site
        </p>
      </div>

      <div className="flex justify-start mb-6">
        <Button
          onClick={() => {
            cards === "" ? setCards("create") : setCards("");
          }}
          variant="contained"
          color="primary"
          sx={{ width: "fit-content" }}
        >
          {cards === "" ? (
            <div className="flex items-center gap-2">
              <AddIcon />
              Criar Mosaico
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <ArrowBackIcon />
              Voltar
            </div>
          )}
        </Button>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-40">
          <div className="text-center">
            <CircularProgress />
            <p className="mt-4 text-gray-600">Carregando mosaicos...</p>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden mb-8 shadow-sm">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">
                Layout dos Mosaicos
              </h2>
              <p className="text-gray-600 mb-4">
                Siga o layout para escolher a posição correta:
              </p>
              <img
                className="mx-auto rounded-lg shadow-sm"
                src="https://i.imgur.com/wXF9UMw.jpg"
                alt="Layout banners"
              />
            </div>
          </div>

          {cards === "create" ? (
            <Create
              setWarning={setWarning}
              handleOpenSnackbar={handleOpenSnackbar}
              setCards={setCards}
            />
          ) : cards === "edit" ? (
            <Edit
              setWarning={setWarning}
              handleOpenSnackbar={handleOpenSnackbar}
              item={item}
              setCards={setCards}
            />
          ) : banners && banners.length > 0 ? (
            <div className="space-y-6">
              {banners.map((banner, index) => (
                <div
                  key={index}
                  className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                >
                  <div className="flex justify-between items-center p-6 border-b border-gray-200">
                    <div className="flex-1">
                      <h2 className="text-xl font-bold text-gray-800 mb-2">
                        {banner.title}
                      </h2>
                      <div className="flex flex-wrap gap-2">
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-medium ${getPositionColor(
                            banner.position
                          )}`}
                        >
                          Posição: {handleposition(banner.position)}
                        </span>
                        {banner.videoUrl && (
                          <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-medium">
                            Com Vídeo
                          </span>
                        )}
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        setCards("edit");
                        setItem(banner);
                      }}
                      className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2"
                    >
                      <EditIcon sx={{ fontSize: 18 }} />
                      Editar
                    </button>
                  </div>
                  <div className="p-6">
                    <div className="flex justify-center items-stretch">
                      <div className="group relative text-base sm:text-sm w-full">
                        <div className="flex justify-center m-2 flex-col md:flex-row gap-6 p-5">
                          <div className="flex-1">
                            <p className="text-sm bg-red-500 text-white mb-3 text-center p-2 rounded-lg font-medium">
                              Imagem Desktop
                            </p>
                            <div>
                              <img
                                src={banner.imgUrl}
                                alt="Desktop"
                                className="object-contain object-center h-56 w-full"
                                onError={(e) => {
                                  e.target.src =
                                    "https://via.placeholder.com/300x600?text=Imagem+Desktop";
                                }}
                              />
                            </div>
                          </div>
                          {banner.imgUrlMobile && (
                            <div className="flex-1">
                              <p className="text-sm bg-blue-500 text-white mb-3 text-center p-2 rounded-lg font-medium">
                                Imagem Mobile
                              </p>
                              <div>
                                <img
                                  src={banner.imgUrlMobile}
                                  alt="Mobile"
                                  className="object-contain object-center h-56 w-full"
                                  onError={(e) => {
                                    e.target.src =
                                      "https://via.placeholder.com/300x600?text=Imagem+Mobile";
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="flex justify-center mb-4">
                          <a
                            href={banner.href}
                            className="block font-medium text-blue-600 hover:text-blue-800 text-center transition-colors"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span
                              className="absolute inset-0 z-10"
                              aria-hidden="true"
                            />
                            {banner.title}
                          </a>
                        </div>
                        <div className="flex justify-center">
                          <p className="text-sm text-gray-600 text-center p-3 bg-gray-50 rounded-lg max-w-md">
                            {banner.text}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-white border border-gray-200 rounded-lg p-8 text-center">
              <p className="text-gray-500 text-lg">
                Nenhum mosaico encontrado. Crie o primeiro mosaico para começar.
              </p>
            </div>
          )}
        </>
      )}
      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};

export default View;
